export const DepositFrequencies = [
	{ id: 1, name: 'One-Time Transfer', code: 'ONE_TIME' },
  { id: 2, name: 'Weekly', code: 'WEEKLY' },
  { id: 3, name: 'Every 2 Weeks', code: 'BIWEEKLY' },
  { id: 4, name: 'Every Month', code: 'MONTH' },
  { id: 5, name: 'Every 3 Months', code: 'QUARTERLY' },
  { id: 6, name: 'Every Year', code: 'YEARLY' }
];

/**
 * Frequency enum - could eventually replace the above DepositFrequencies
 */
export const Frequency = {
  ONE_TIME: { id: 1, name: 'One-Time Transfer', code: 'ONE_TIME' },
  WEEKLY: { id: 2, name: 'Weekly', code: 'WEEKLY' },
  BIWEEKLY: { id: 3, name: 'Every 2 Weeks', code: 'BIWEEKLY' },
  MONTH: { id: 4, name: 'Every Month', code: 'MONTH' },
  QUARTERLY: { id: 5, name: 'Every 3 Months', code: 'QUARTERLY' },
  YEARLY: { id: 6, name: 'Every Year', code: 'YEARLY' }
};
